import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiAppointmentCtaSectionDTO,
  AppointmentCtaSectionDTO,
} from "@lib/strapi/dtos/components/sections/appointmentCtaSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class AppointmentCtaSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiAppointmentCtaSectionDTO,
  ): Promise<AppointmentCtaSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new AppointmentCtaSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.prompt = await parseStrapiContent(strapiData.prompt);
    dto.style = strapiData.style;
    dto.appearance = strapiData.appearance;
    return dto;
  }
}
